import React from 'react';
import { v1 as uuid } from 'uuid';
import $ from 'jquery';

import messages from './Messages';
import { IProviderItemViewWithData } from '../../../store/providers/providerTypes';

export interface IComponentProps {
  openItem: {
    item: IProviderItemViewWithData;
    status:
      | 'edit'
      | 'settings'
      | 'identification'
      | 'chart'
      | 'analyse'
      | 'versions'
      | 'view'
      | 'responses'
      | 'patientsForm';
  };
  isOpen: boolean;
  onMinimize?: () => void;
  showAnimation?: boolean;
}

export interface IComponentState {}

class ItemManagerModal<
  P extends IComponentProps = IComponentProps,
  S extends IComponentState = IComponentState,
> extends React.Component<P, S> {
  protected unsave: boolean;
  protected isOpen: boolean;
  protected modal: HTMLDivElement | null = null;
  protected saveAlertModal: HTMLDivElement | null = null;
  protected modalId: string;
  protected onClose: (() => void) | null = null;

  constructor(props: P) {
    super(props);
    this.unsave = false;
    this.isOpen = false;
    this.modalId = uuid();

    this.cancelClose = this.cancelClose.bind(this);
    this.closeWithoutSaving = this.closeWithoutSaving.bind(this);
  }

  componentDidMount() {
    if (this.modal) {
      ($(this.modal) as any).modal({
        overlay: false,
        dismissible: false,
        complete: () => {
          this.isOpen = false;
        },
      });
    }

    if (this.saveAlertModal) {
      ($(this.saveAlertModal) as any).modal({
        dismissible: false,
      });
    }
    this.componentDidUpdate();
  }

  componentDidUpdate() {
    if (this.props.isOpen && this.modal) {
      ($(this.modal) as any).modal('open');
      this.isOpen = true;
    } else if (this.isOpen && this.modal) {
      ($(this.modal) as any).modal('close');
      this.isOpen = false;
    }
  }

  getModalStyle(): React.CSSProperties {
    return {
      width: '100%',
      top: '0% !important',
      height: `calc(100% - ${this.props.onMinimize ? '3rem' : '0px'})`,
      maxHeight: '100%',
      overflow: 'visible',
      boxShadow: 'none',
    };
  }

  closeWithoutSaving(e: any) {
    e.preventDefault();
    if (this.saveAlertModal) {
      ($(this.saveAlertModal) as any).modal('close');
    }
    this.onClose?.();
  }

  cancelClose(e: any) {
    e.preventDefault();
    if (this.saveAlertModal) {
      ($(this.saveAlertModal) as any).modal('close');
    }
  }

  close(success: () => void) {
    if (!this.unsave) {
      if (this.modal) {
        ($(this.modal) as any).modal('close');
      }
      success();
    } else {
      this.onClose = success;
      if (this.saveAlertModal) {
        ($(this.saveAlertModal) as any).modal('open');
      }
    }
  }

  handleChange() {
    this.unsave = true;
  }

  handleSaved() {
    this.unsave = false;
  }

  renderChild(): React.ReactNode {
    return null;
  }

  render(): React.ReactNode {
    const item = this.props.openItem.item;
    const saveAlertModalId = `${this.modalId}saveAlert`;
    return (
      <span>
        <div
          id={this.modalId}
          className="modal"
          ref={(el) => {
            this.modal = el;
          }}
          style={this.getModalStyle()}
        >
          {this.renderChild()}
        </div>
        <div
          id={saveAlertModalId}
          className="modal"
          ref={(el) => {
            this.saveAlertModal = el;
          }}
        >
          <div className="modal-content">
            <h4>{item.data.name}</h4>
            <p>{messages.exitWithoutSave(item.data.name as string)}</p>
          </div>
          <div className="modal-footer">
            <a
              href="#!"
              onClick={this.cancelClose}
              className="modal-action waves-effect white-text green btn-flat"
            >
              {messages.cancel}
            </a>
            <a
              href="#!"
              onClick={this.closeWithoutSaving}
              className="modal-action waves-effect waves-red btn-flat"
            >
              {messages.closeWithoutSaving}
            </a>
          </div>
        </div>
      </span>
    );
  }
}

export default ItemManagerModal;
